import {listFiltersPlaces} from '@adv-mt/mt-list-filters'
import {searchTagsPlaces} from '@adv-mt/mt-search-tags'

export const DESIGNS = {
  DEFAULT: 'default',
  WRAPPED: 'wrapped'
}

export const PLACES = {
  ADS_LIST: 'adsList',
  DEALERS_LIST: 'dealersList',
  PROFESSIONAL_STOCK_RENTING: 'professionalStockRenting',
  PROFESSIONAL_STOCK: 'professionalStock',
  TECHNICAL_DETAILS: 'technicalDetails'
}

export const LIST_FILTERS_PLACES_DICTIONARY = {
  [PLACES.ADS_LIST]: listFiltersPlaces.SIDEBAR,
  [PLACES.PROFESSIONAL_STOCK]: listFiltersPlaces.SIDEBAR,
  [PLACES.PROFESSIONAL_STOCK_RENTING]: listFiltersPlaces.SIDEBAR,
  [PLACES.SUBSCRIPTION_ADS_LIST]: listFiltersPlaces.SIDEBAR
}

export const SEARCH_TAGS_PLACES_DICTIONARY = {
  [PLACES.ADS_LIST]: searchTagsPlaces.ADS_LIST,
  [PLACES.PROFESSIONAL_STOCK]: searchTagsPlaces.PROFESSIONAL_STOCK,
  [PLACES.PROFESSIONAL_STOCK_RENTING]: searchTagsPlaces.PROFESSIONAL_STOCK_RENTING,
  [PLACES.SUBSCRIPTION_ADS_LIST]: searchTagsPlaces.SUBSCRIPTION_ADS_LIST
}

export const SEARCH_USE_CASE_BY_PLACE = {
  [PLACES.ADS_LIST]: 'get_url_params_search_use_case',
  [PLACES.PROFESSIONAL_STOCK]: 'get_stock_url_params_search_use_case',
  [PLACES.PROFESSIONAL_STOCK_RENTING]: 'get_stock_url_params_search_use_case',
  [PLACES.SUBSCRIPTION_ADS_LIST]: 'get_url_params_search_use_case',
  [PLACES.TECHNICAL_DETAILS]: 'get_search_url_vehicles_use_case'
}

export const DEFAULT_SEARCH_USE_CASE = 'get_search_url_ads_use_case'
